import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Notification,
} from 'base-ui'

import { MarketplacePartnerRegisterPageAutocomplete } from '../MarketplacePartnerRegisterPageAutocomplete'

export const MarketplacePartnerRegisterPageFormBrandsAutocomplete: FC = () => {
  const intl = useIntl()

  return (
    <div className="flex flex-col gap-4">
      <Notification
        severity="info"
        title={intl.formatMessage({
          id: 'marketplacePartnerRegisterPage.brands.autocomplete.info.title',
        })}
        variant="primary"
      >
        <FormattedMessage id="marketplacePartnerRegisterPage.brands.autocomplete.info.message" />
      </Notification>
      <Accordion>
        <AccordionSummary>
          <div className="flex w-full items-center justify-between">
            <FormattedMessage
              defaultMessage="Marken"
              id="marketplacePartnerRegisterPage.brands.autocomplete.label"
            />
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <MarketplacePartnerRegisterPageAutocomplete />
        </AccordionDetails>
      </Accordion>
    </div>
  )
}
